import {
    RequestConfigFunction,
} from '../../types/request.types'
import {
    LongTermLeasePositionResponse,
} from './LongTermLeasePosition.types'

type LongTermLeasePositionRequests = {
    get: RequestConfigFunction<{longTermLeasePositionId: number}, LongTermLeasePositionResponse>,
    update: RequestConfigFunction<{longTermLeasePositionId: number}>,
    archive: RequestConfigFunction<{longTermLeasePositionId: number}>,
}

const longTermLeasePositionRequests: LongTermLeasePositionRequests = {
    get: ({
        longTermLeasePositionId,
    }) => {
        return {
            url: `longtermleaseposition/${longTermLeasePositionId}`,
            method: 'GET',
        }
    },
    update: ({
        longTermLeasePositionId,
    }) => {
        return {
            url: `longtermleaseposition/${longTermLeasePositionId}`,
            method: 'PATCH',
        }
    },
    archive: ({
        longTermLeasePositionId,
    }) => {
        return {
            url: `longtermleaseposition/${longTermLeasePositionId}/archive`,
            method: 'PATCH',
        }
    },
}

export default longTermLeasePositionRequests
